import React from 'react';
import { Wine } from 'lucide-react';

export default function BarCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('bar-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-amber-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Wine className="w-12 h-12 text-amber-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Name Your Bar?
        </h2>
        <p className="text-xl text-amber-100 mb-8">
          Join thousands of bar owners who've found their perfect name with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-amber-600 text-lg px-8 py-4 rounded-lg hover:bg-amber-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Create Your Bar Name Now!
        </button>
        <p className="mt-6 text-sm text-amber-200">
          Perfect for pubs, cocktail lounges, sports bars, and more
        </p>
      </div>
    </section>
  );
}